import React, { Component } from 'react'
import Header from './header'
import LeftBar from './leftBar'
import moment from 'moment'
import {
  calcelByDoctor,
  cancellAppointment,
  disconnectCalander,
  getAppointment,
  loadAllAppointmentForDoctor,
  loadAppointmentDetail,
} from '../../../store/appointment'
import { loadSeo } from '../../../store/seo'
import {
  getDoctor,
  loadDoctorProfile,
  loadoffSchedule,
  offSchedule,
  offScheduleDeactivate,
} from '../../../store/doctor'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { Modal } from 'react-bootstrap'
import verticalDots from '../../../include/images/vertical-dots.svg'
import loaderIcon from '../../../include/images/loading-icon.svg'
import _ from 'lodash'
import AlertSuccess from '../../common/alertSuccess'
import AlertError from '../../common/alertError'
import { toast } from 'react-toastify'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction' // needed for dayClick
//import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import { Link } from 'react-router-dom'
import AvtarImage from '../../common/avtarImage'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import SelectOptions from '../common/selectOptions'

const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
class Calender extends Component {
  state = {
    popUp: false,
    popUp2: false,
    loading: false,
    dropDown: false,
    selectedEvent: false,
    appointModel: false,
    timeModel: false,
    selectedSlot: false,
    formData: {
      checkBox: true,
      type: 'online',
    },
    finalData: [],
    offSchedules: [],
    sidebarToogle: false,
    startTime: '',
    endTime: '',
    fullDay: false,
    startStr: '',
    events:[]
  }

  timeDropdownNew = [
    { value: '0000', label: '12:00 AM' },
    { value: '0030', label: '12:30 AM' },
    { value: '0100', label: '01:00 AM' },
    { value: '0130', label: '01:30 AM' },
    { value: '0200', label: '02:00 AM' },
    { value: '0230', label: '02:30 AM' },
    { value: '0300', label: '03:00 AM' },
    { value: '0330', label: '03:30 AM' },
    { value: '0400', label: '04:00 AM' },
    { value: '0430', label: '04:30 AM' },
    { value: '0500', label: '05:00 AM' },
    { value: '0530', label: '05:30 AM' },
    { value: '0600', label: '06:00 AM' },
    { value: '0630', label: '06:30 AM' },
    { value: '0700', label: '07:00 AM' },
    { value: '0730', label: '07:30 AM' },
    { value: '0800', label: '08:00 AM' },
    { value: '0830', label: '08:30 AM' },
    { value: '0900', label: '09:00 AM' },
    { value: '0930', label: '09:30 AM' },
    { value: '1000', label: '10:00 AM' },
    { value: '1030', label: '10:30 AM' },
    { value: '1100', label: '11:00 AM' },
    { value: '1130', label: '11:30 AM' },
    { value: '1200', label: '12:00 PM' },
    { value: '1230', label: '12:30 PM' },
    { value: '1300', label: '01:00 PM' },
    { value: '1330', label: '01:30 PM' },
    { value: '1400', label: '02:00 PM' },
    { value: '1430', label: '02:30 PM' },
    { value: '1500', label: '03:00 PM' },
    { value: '1530', label: '03:30 PM' },
    { value: '1600', label: '04:00 PM' },
    { value: '1630', label: '04:30 PM' },
    { value: '1700', label: '05:00 PM' },
    { value: '1730', label: '05:30 PM' },
    { value: '1800', label: '06:00 PM' },
    { value: '1830', label: '06:30 PM' },
    { value: '1900', label: '07:00 PM' },
    { value: '1930', label: '07:30 PM' },
    { value: '2000', label: '08:00 PM' },
    { value: '2030', label: '08:30 PM' },
    { value: '2100', label: '09:00 PM' },
    { value: '2130', label: '09:30 PM' },
    { value: '2200', label: '10:00 PM' },
    { value: '2230', label: '10:30 PM' },
    { value: '2300', label: '11:00 PM' },
    { value: '2330', label: '11:30 PM' },
    { value: '2400', label: '12:00 AM' },
  ]

  calendarRef = React.createRef()

  isHolidaySelected = () => {
    const { selectedSlot, offSchedules } = this.state

    if (!selectedSlot || !selectedSlot.start) {
        return false
    }

    const selectedDate = moment(selectedSlot.start).format('YYYY-MM-DD')

    return offSchedules.some(
        ele =>
            ele.type === 'holiday' &&
            moment.utc(ele.start).format('YYYY-MM-DD') === selectedDate
    )
  }

  toggleHoliday = () => {
    const isHoliday = this.isHolidaySelected()

    if (isHoliday) {
        const holiday = this.state.offSchedules.find(
            ele =>
                ele.type === 'holiday' &&
                moment.utc(ele.start).format('YYYY-MM-DD') ===
                    moment(this.state.selectedSlot.start).format('YYYY-MM-DD')
        )

        if (holiday) {
            this.unBlock(holiday._id)
        }

        return
    }

    this.setState({ loading: true })

    const selectedDate = moment(this.state.selectedSlot.start)

    const Payload = {
        start_time: selectedDate.utc().toString(),
        date: selectedDate.utc().format('YYYY-MM-DD'),
        type: 'holiday',
        inActive: true,
    }

    this.props.offSchedule(Payload, this.callback)
}

  reSchule = e => {
    e.preventDefault()
    this.props.history.push({
      pathname: '/doctor/reschedule-appointment',
      state: {
        appointment_id: this.state.selectedEvent.data._id,
        returnUrl: '/doctor/dashboard/calender',
      },
    })
  }
  cancellAppointment = e => {
    e.preventDefault()
    this.props.cancellAppointment(
      this.state.selectedEvent.data._id,
      this.callBack
    )
    this.setState({ loader: true })
  }
  callBack = res => {
    this.toggle()
    this.setState({ loader: false })
    this.props.loadAllAppointmentForDoctor({calendar: true})
    if (res.status === 200) {
      toast(<AlertSuccess message={'Appointment cancelled successfully'} />)
    } else {
      toast(<AlertError message={res.data.error} />)
    }
  }
  handleDisconnect = e => {
    e.preventDefault()
    this.props.disconnectCalander(this.disconnectCallback)
  }
  disconnectCallback = (res) => {
    this.toggle2()
    if (res && res.status === 200) {
      this.props.loadDoctorProfile()
      toast(<AlertSuccess message="Calander disconnected." />);
    } else {
      toast(<AlertError message="Something went wrong." />);
    }
  };
  toggle = e => {
    if (e) e.preventDefault()
    this.setState({ popUp: !this.state.popUp })
  }
  toggle2 = e => {
    if (e) e.preventDefault()
    this.setState({ popUp2: !this.state.popUp2 })
  }
  componentDidUpdate = (prevProps, prevState) => {
    if (
      !this.props.offSchedulesLoading &&
      this.props.offSchedulesLoading !== prevProps.offSchedulesLoading
    ) {
      const offSchedules = []
      this.props.offSchedules.forEach(element1 => {
        const isHoliday = element1.type === 'holiday'

        let backgroundColor = '#dc3545'
        let flagColor = ''
        
        if (element1.type === 'online') {
          flagColor = '#61C395'
        } else if (element1.type === 'physical') {
          flagColor = '#5FB5D7'
        } else if (element1.type === 'physical2') {
          flagColor = '#8c6dce'
        }
        const hasTimeRange = element1.end_time && !isHoliday

        const prepairData = {
          start: hasTimeRange
            ? new Date(moment(element1.start_time).utc())
            : moment.utc(element1.start_time).format('YYYY-MM-DD'),

          ...(hasTimeRange && {
            end: new Date(moment(element1.end_time)),
          }),

          display: isHoliday ? 'background' : 'block',
          flagColor,
          isOffSchedule: true,
          backgroundColor: isHoliday ? 'red' : 'transparent',
          // borderColor: backgroundColor,

          title: isHoliday
            ? ''
            : `
              ${
                element1.end_time && !isHoliday
                  ? ` Blocked (${moment.utc(element1.start_time).format('h:mm A')} - ${moment.utc(element1.end_time).format('h:mm A')})`
                  : 'All Slots Blocked'
              }`,

          allDay: isHoliday || !hasTimeRange,

          _id: element1._id,
          type: element1.type,
        }

        offSchedules.push(prepairData)
      })

      this.setState({ offSchedules })
    }
    if (
      !this.props.loadingDoctorAppointment &&
      this.props.loadingDoctorAppointment !== prevProps.loadingDoctorAppointment
    ) {
      
      let events = this.props.getAppointment.data.map(ea => ({
        display: 'block',
        data: ea,
        id: ea.appointment_no,
        title: ea.patient_id
          ? `${ea.patient_id.first_name} ${
              ea.patient_id.last_name
            } - ${_.upperCase(ea.appointment_type)}`
          : 'New Patient',
        start: new Date(moment(ea.appointment_time).utc()),
        end: new Date(
          this.calculateEnd(ea.appointment_time, ea.doctor_id.schedules.time)
        ),       
        // borderColor:
        //   ea.appointment_type === 'online'
        //     ? '#5FB5D7'
        //     : ea.appointment_type === 'walkin'
        //     ? '#582BB8'
        //     : '#61C395',
        // backgroundColor:
        //   ea.appointment_type === 'online'
        //     ? '#EDFFF6'
        //     : ea.appointment_type === 'walkin'
        //     ? '#E6DFF5'
        //     : '#ebfdf5',
        borderColor:
          ea.appointment_type === 'online'
            ? '#61C395'
            : ea.appointment_type === 'clinic'
            ? ea.clinic_type === 2
              ? '#8c6dce'
              : '#5FB5D7'
            : '#5FB5D7',

        backgroundColor:
          ea.appointment_type === 'online'
            ? '#def9ed'
            : ea.appointment_type === 'clinic'
            ? ea.clinic_type === 2
              ? '#eee7fb'
              : '#e0f5fb'
            : '#e0f5fb',
        textColor: '#3b2772',
        eventRender: e => console.log('eventRender', e),
      }))
      
      this.setState({ events })
    }
    if (
      !this.props.profileLoading &&
      this.props.profileLoading !== prevProps.profileLoading
    ) {
      const finalData = []
      const allDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
      Object.keys(this.props.doctorProfile.schedules).forEach(element => {
        if (
          Array.isArray(this.props.doctorProfile.schedules[element]) &&
          this.props.doctorProfile.schedules[element].length > 0
        ) {
          allDays.splice(allDays.indexOf(element), 1)
        }
      })

      allDays.forEach(elementDay => {
        const record = {
          daysOfWeek: [days.indexOf(elementDay)], //Sundays and saturdays
          display: 'background',
          color: 'red',
          allDay: true,
        }
        finalData.push(record)
      })

      this.setState({ finalData })
    }
  }

  dropDownToggle = e => {
    e.preventDefault()
    this.setState({ dropDown: !this.state.dropDown })
  }

  toggleAppointModel = e => {
    if (e) e.preventDefault()
    this.setState({ appointModel: !this.state.appointModel })
  }
  toggleTimeModel = e => {
    if (e) e.preventDefault()
    this.setState({ timeModel: !this.state.timeModel })
  }

  componentDidMount() {
    document.body.className = 'dashboard'
    //this.props.loadAllAppointmentForDoctor({})
    this.props.loadoffSchedule()
  }

  handleLoadAppointments = val => {
    this.props.loadAllAppointmentForDoctor({
      ...val,
      calendar: true,
    })
  }

  calculateEnd = (time, minut) => {
    var dt = new Date(time)
    dt.setMinutes(dt.getMinutes() + minut)
    return moment(dt).utc()
  }

  handleRadio = type => {
    const { formData } = this.state
    formData.type = type
    this.setState({ formData })
  }

  handleCheck = () => {
    const { formData } = this.state
    formData.checkBox = !formData.checkBox
    this.setState({ formData })
  }

  submitForm = e => {
    this.setState({ loading: true })
    e.preventDefault()

    const end_time =
      this.state.selectedSlot.startStr.length !== 10
        ? moment(this.state.selectedSlot.end).utc()
        : false

    let Payload = {}

    if (this.state.fullDay || !this.state.startTime) {
      Payload = {
        start_time: moment(this.state.selectedSlot.start).utc().toString(),
        date: moment(this.state.selectedSlot.start).utc().format('YYYY-MM-DD'),
        type: this.state.formData.type,
        inActive: this.state.formData.checkBox,
      }
    } else {
      const obj = { ...this.state.selectedSlot }
      let startTime = moment(obj.start)
        .set('hour', Number(this.state.startTime.substring(0, 2)) + 5)
        .set('minute', Number(this.state.startTime.substring(2, 4)) + 30)
        .toString()
      let endTime = moment(obj.start)
        .set('hour', Number(this.state.endTime.substring(0, 2)) + 5)
        .set('minute', Number(this.state.endTime.substring(2, 4)) + 30)
        .toString()

      Payload = {
        start_time: startTime,
        end_time: endTime,
        date: moment(this.state.selectedSlot.start).utc().format('YYYY-MM-DD'),
        type: this.state.formData.type,
        inActive: this.state.formData.checkBox,
      }
    }
    if (this.state.selectedSlot.startStr.length !== 10) {
      Payload.end_time = new Date(end_time).toString()
    }

    this.props.offSchedule(Payload, this.callback)
  }

  unBlock = id => {
    this.setState({ loading: true })
    this.props.offScheduleDeactivate(id, this.callback)
  }

  callback = res => {
    if (res.status === 200) {
      this.setState({
        loading: false,
        startTime: '',
        endTime: '',
      },
      () => {
        this.props.loadoffSchedule()
      }
      )

      toast(<AlertSuccess message={'Information saved'} />)
    } else {
      this.setState({ loading: false })
      toast(<AlertError message={res.data.error} />)
    }
  }

  toggleSidebar = e => {
    if (e) e.preventDefault()
    this.setState({ sidebarToogle: !this.state.sidebarToogle })
  }

  scrollToCurrentTime = () => {
    const calendarApi = this.calendarRef.current?.getApi()

    if (!calendarApi) return

    const viewType = calendarApi.view.type

    if (viewType === 'timeGridDay' || viewType === 'timeGridWeek') {
      calendarApi.scrollToTime(moment().format('HH:mm:ss'))
    }
  }

  selectChangeOption = e => {
    const { value, name } = e
    this.setState({ [name]: value })
  }

  render() {
    var today = new Date()
    today.setHours(today.getHours() + 5)
    today.setMinutes(today.getMinutes() + 30)

    let filterOption = []

    const currentSlotItem =
      this.state.selectedSlot &&
      this.props.doctorProfile.schedules[
        moment(this.state.selectedSlot.start).format('ddd').toLowerCase()
      ]

    const currentSlot =
      (currentSlotItem &&
        (this.state.formData.type && this.state.formData.type === 'online'
          ? currentSlotItem.filter(ele => ele.is_online)
          : this.state.formData.type === 'physical'
          ? currentSlotItem.filter(ele => ele.is_clinic)
          : this.state.formData.type === 'physical2'
          ? currentSlotItem.filter(ele => ele.is_clinic2)
          : [...currentSlotItem])) ||
      []

    let mapData =
      (currentSlot &&
        currentSlot.map(ele => {
          const startIndex = this.timeDropdownNew.findIndex(
            item => item.value == ele.start_time
          )
          const endIndex = this.timeDropdownNew.findIndex(
            item => item.value == ele.end_time
          )
          const currentEle = this.timeDropdownNew.slice(
            startIndex,
            endIndex + 1
          )
          filterOption = [...filterOption, ...currentEle]
        })) ||
      []

    const uniqueOptions = filterOption.filter((obj, index) => {
      return index === filterOption.findIndex(o => obj.value === o.value)
    })

    const filter = this.state.offSchedules.filter(ele => {
      return (
        moment.utc(ele.start).format('YYYY-MM-DD') ===
          moment(this.state.selectedSlot.start).format('YYYY-MM-DD') &&
        ele.type == this.state.formData.type
      )
    })

    return (
      <>
        <ReactTooltip className='testPurple' id='calender-tooltip'/>
        <div class={this.state.sidebarToogle ? 'dashboard on' : 'dashboard'}>
          <LeftBar />
          <Header
            sidebarToogle={this.state.sidebarToogle}
            toggleSidebar={this.toggleSidebar}
          />
          <div class='dashboard-main-container'>
            {/* <div class="dashboard-main-heading">
            <h2>
              Welcome, <strong>Dr. Shah</strong>
            </h2>
            <p>Have a nice day at work</p>
          </div> */}
            <div className='dashboard-wrapper'>
              <div class='dw-header d-flex align-items-center'>
                <h3>
                  My Calendar{' '}
                  {this.props.doctorProfile.googleTokens?.refresh_token ? (
                    <>
                      <i
                        className="fa-beat fa-sharp-duotone fa-circle-dot fa-sm"
                        style={{
                          "--fa-primary-color": "#8bb044",
                          "--fa-secondary-color": "#8bb044"
                        }}
                      ></i> 
                      <a
                        className='btn btn-xs btn-outline no-shadow ml-2'
                        href='#'
                        style={{"fontSize": "13px"}}
                        onClick={e => {
                          this.toggle2(e)
                        }}>
                        {' '} Desync Calendar
                      </a>
                    </>
                  ) : (
                    <a
                      className='btn btn-xs btn-outline no-shadow ml-2'
                      href={process.env.REACT_APP_APIBASE + `auth/google?doctorId=${this.props.doctorProfile._id}`}
                      style={{"fontSize": "13px"}}
                    >
                      Connect with Google
                    </a>
                  )}
                </h3>
                <div class='dw-right ml-auto mt-3'>
                  <Link
                    data-tooltip-id="calender-tooltip"
                    data-tooltip-content='For walk in/ online patients when you want to record their visit (physical, online, telephonic). Only for existing patients in your record. Else add new patient first to record their visit.'
                    to='/doctor/recordVisit'
                    class='btn btn-outline no-shadow'>
                    Record Visit
                  </Link>
                  <Link
                    data-tooltip-id="calender-tooltip"
                    data-tooltip-content='When you want to create an appointment for your existing patient on their behalf. If new patient then add the patient first.'
                    to='/doctor/newAppointment'
                    class='btn btn-outline no-shadow'>
                    + New Appointment
                  </Link>
                  <Link
                    data-tooltip-id="calender-tooltip"
                    data-tooltip-content='When you want to add a new patient to your dashboard so that you can create an appointment for them or record their visits.'
                    to='/doctor/addPatient'
                    class='btn btn-default'>
                    + New Patient
                  </Link>
                </div>
              </div>
              <div className='dw-main-content'>
                <FullCalendar
                  ref={this.calendarRef}
                  initialDate={new Date()}
                  scrollTime={moment().format('HH:mm:ss')}
                  scrollTimeReset={true}
                  slotDuration={'01:00:00'}
                  nowIndicator={true}
                  now={today} // just for demo
                  displayEventTime={false}
                  eventTimeFormat={{
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  }}
                  stickyHeaderDates={true}
                  height={650}
                  textEscape={false}
                  select={e => {
                    
                    this.toggleTimeModel()
                    this.setState({ selectedSlot: e })
                  }}
                  longPressDelay={1}
                  selectable
                  timeZone='Asia/Kolkata'
                  headerToolbar={{
                    left: 'prev,today,next',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay',
                  }}
                  schedulerLicenseKey='CC-Attribution-NonCommercial-NoDerivatives'
                  weekends={true}
                  plugins={[
                    dayGridPlugin,
                    timeGridPlugin,
                    listPlugin,
                    interactionPlugin,
                    //resourceTimelinePlugin,
                  ]}
                  initialView='dayGridMonth'
                  events={[
                    ...(this.state.events || []),
                    ...(this.state.finalData || []),

                    ...(this.state.offSchedules || []).map(event => {
                      let borderColor = '#dc3545'

                      if (event.type === 'online') {
                        borderColor = '#61C395'
                      } else if (event.type === 'physical') {
                        borderColor = '#5FB5D7'
                      } else if (event.type === 'physical2') {
                        borderColor = '#8c6dce'
                      }

                      return {
                        ...event,
                        // backgroundColor,
                        borderColor: borderColor,
                      }
                    }),
                  ]}
                  eventContent={arg => {
                    const { flagColor, isOffSchedule, type } =
                      arg.event.extendedProps

                    if (isOffSchedule && type !== 'holiday') {
                      return (
                        <span
                          className='fc-event-title'
                          title={arg.event.title}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '2px 4px',
                            fontSize: '10px',
                            color: '#3b2772',
                          }}
                        >
                          <i
                            className='fa-solid fa-flag-pennant'
                            style={{
                              color: flagColor,
                              fontSize: '16px',
                            }}
                          />
                          {arg.event.title}
                        </span>
                      )
                    }

                    return (
                      <div className='fc-event-title fc-sticky'>
                        {arg.event.title || ''}
                      </div>
                    )
                  }}
                  // events={this.state.events && [
                  //   ...this.state.events,
                  //   ...this.state.finalData,
                  //   ...this.state.offSchedules,
                  // ]}
                  eventClick={e => {
                    const event = e.event
                    const { type, isOffSchedule } = event.extendedProps

                    if (isOffSchedule) {
                      this.setState(
                        {
                          selectedSlot: {
                            start: event.start,
                            end: event.end,
                            startStr: event.startStr,
                            endStr: event.endStr,
                            allDay: event.allDay,
                          },
                          formData: {
                            ...this.state.formData,
                            type,
                          },
                        },
                        () => {
                          this.toggleTimeModel()
                        }
                      )

                      return
                    }

                    this.setState({
                      selectedEvent: event.extendedProps,
                    })

                    this.toggleAppointModel()
                  }}
                  datesSet={dateInfo => {
                    setTimeout(() => this.scrollToCurrentTime(), 0)
                    const currStart = moment(dateInfo.startStr).format(
                        'YYYY-MM-DD'
                      ),
                      currEnd = moment(dateInfo.endStr).format('YYYY-MM-DD')
                    if (this.state.startStr != currStart) {
                      this.setState(
                        {
                          startStr: currStart,
                        },
                        () => {
                          this.handleLoadAppointments({
                            start_date: currStart,
                            end_date: currEnd,
                          })
                        }
                      )
                    }
                  }}
                  viewDidMount={() => {
                    this.scrollToCurrentTime()
                  }}
                />
                <div class='dm-footer d-flex align-items-center'>
                  <div class='calendar-cradits d-flex align-items-center add-scrollbar scrollbar-dynamic'>
                    <div class='d-flex align-items-center'>
                      <div class='cc-item'>
                        <h5>Legend:</h5>
                      </div>
                      <div class='cc-item cc-physical'>
                        <div class='cc-check-icon'></div>
                        Online
                      </div>
                      <div class='cc-item '>
                        <div class='cc-check-icon'></div>
                        Clinic 1
                      </div>
                      <div class='cc-item cc-walk-in'>
                        <div class='cc-check-icon'></div>
                        Clinic 2
                      </div>
                      <div class='cc-item cc-shedule'>
                        <div class='cc-check-icon'></div>
                        Schedule Off
                      </div>
                      {/* <div class="cc-item cc-online">
                        <div class="cc-check-icon"></div>
                        Only Online
                      </div>
                      <div class="cc-item">
                        <div class="cc-check-icon"></div>
                        Only Clinic
                      </div> */}
                    </div>
                    <div class='calendar-cradits-right d-flex align-items-center'>
                      <div class='add-current-time-indicator'>
                        <span class='dots'></span>
                      </div>
                      Current Time
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal
            show={this.state.appointModel}
            onHide={this.toggleAppointModel}
            centered
            dialogClassName='profile'>
            {' '}
            <div class='dropright-header'>
              <h3>Appointment Details</h3>
              <div class='dropright'>
                <a
                  href='#!'
                  onClick={e => this.dropDownToggle(e)}
                  class='dropdown-toggle'
                  data-toggle='dropdown'>
                  <img src={verticalDots} alt='' />
                </a>
                <div
                  class={
                    this.state.dropDown
                      ? 'dropdown-menu2 add-arrow-shape show'
                      : 'dropdown-menu2 add-arrow-shape '
                  }>
                  <a
                    class='dropdown-item'
                    href='#'
                    onClick={e => {
                      this.dropDownToggle(e)

                      this.props.history.push({
                        pathname: '/doctor/patient-detail',
                        state: this.state.selectedEvent.data.patient_id._id,
                      })
                    }}>
                    View Profile
                  </a>
                  <a
                    class='dropdown-item'
                    href='#'
                    onClick={e => {
                      this.dropDownToggle(e)

                      this.props.history.push({
                        pathname: '/doctor/dashboard/case-record',
                        state: this.state.selectedEvent.data.patient_id._id,
                      })
                    }}>
                    Case Records
                  </a>
                  <a
                    class='dropdown-item'
                    href='#'
                    onClick={e => {
                      this.dropDownToggle(e)
                      this.toggle(e)
                      this.toggleAppointModel(e)
                    }}>
                    Modify Appointment
                  </a>
                </div>
              </div>

              <div className='person-details-box d-flex align-items-center flex-grow-1'>
                <div className='person-img'>
                  {this.state.selectedEvent &&
                  this.state.selectedEvent.data.patient_id.thumb ? (
                    <img
                      src={
                        process.env.REACT_APP_S3URL +
                        this.state.selectedEvent.data.patient_id.thumb
                      }
                      alt=''
                    />
                  ) : (
                    <AvtarImage />
                  )}
                </div>
                <div className='person-text-box'>
                  <h3>
                    {this.state.selectedEvent &&
                      this.state.selectedEvent.data.patient_id.first_name +
                        this.state.selectedEvent.data.patient_id.last_name}
                  </h3>
                  <p>
                    {this.state.selectedEvent &&
                      this.state.selectedEvent.data.patient_id
                        .yesmindy_identification_number}
                  </p>
                </div>
              </div>
            </div>
            <a href='#!' className='dropright-body'>
              <p>Upcoming appointment</p>
              <div className='dropright-status online d-flex align-items-center'>
                <p>
                  On{' '}
                  <strong>
                    {moment(
                      this.state.selectedEvent &&
                        this.state.selectedEvent.data.appointment_time
                    )
                      .utc()
                      .format('D/M')}
                  </strong>{' '}
                  at{' '}
                  <strong>
                    {moment(
                      this.state.selectedEvent &&
                        this.state.selectedEvent.data.appointment_time
                    )
                      .utc()
                      .format('hh:mm a')}
                  </strong>
                </p> 
                {this.state.selectedEvent && 
                 this.state.selectedEvent.data.duration &&
                  <span className='status'>
                  {this.state.selectedEvent &&
                    `${_.startCase(this.state.selectedEvent.data.duration)} Mins`}
                </span>
                }
                <span className='status'>
                  {this.state.selectedEvent &&
                    _.startCase(this.state.selectedEvent.data.appointment_type)}
                </span>
              </div>
            </a>
            <div class='dropright-footer'>
              <a
                href='#!'
                class='btn btn-blue-outline'
                onClick={e => {
                  this.dropDownToggle(e)
                  this.props.history.push({
                    pathname: '/doctor/patient-detail',
                    state: this.state.selectedEvent.data.patient_id._id,
                  })
                }}>
                View Notes & Thoughts
              </a>
              <a className='m-4' onClick={this.toggleAppointModel} href='#!'>
                <b>Close</b>
              </a>
            </div>
            {/* <Modal.Header closeButton>
            <Modal.Title>Appointment Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>Appointment Detail</Modal.Body> */}
          </Modal>
          <Modal
            className='modal fade'
            show={this.state.timeModel}
            onHide={this.toggleTimeModel}
            centered
            dialogClassName='profile'
            contentClassName='p-0'>
            {this.state.selectedSlot.start && (
              <div class='tbm-box'>
                <div className='text-right mb-2'>
                  <a
                    href='#!'
                    className='modal-close-btn'
                    onClick={this.toggleTimeModel}
                    aria-label='Close'>
                    <i
                      className='fa-light fa-xmark fa-lg'
                      style={{ color: '#180058' }}
                    />
                  </a>
                </div>
                <div class='tbm-head'>
                  {this.state.selectedSlot.startStr.length !== 10 ? (
                    <p>
                      Select options to block time from{' '}
                      <strong>
                        {moment(this.state.selectedSlot.start)
                          .utc()
                          .format('lll')}{' '}
                      </strong>{' '}
                      to{' '}
                      <strong>
                        {moment(this.state.selectedSlot.end)
                          .utc()
                          .format('h:mm a')}
                      </strong>
                    </p>
                  ) : (
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0">
                      Select options to block time for{' '}
                      <strong>
                          {moment(this.state.selectedSlot.startStr).format(
                              'MMMM Do YYYY'
                          )}
                      </strong>
                    </p>
                <a
                  href='#!'
                  onClick={this.toggleHoliday}
                  disabled={this.state.loading}
                  className="holiday-toggle-btn"
                > <strong>Holiday Mode</strong>{' '}
                  <i
                    className={
                      this.isHolidaySelected()
                        ? "fa-duotone fa-xl fa-solid fa-toggle-large-on active"
                        : "fa-duotone fa-xl fa-solid fa-toggle-off"
                    }
                    style={{
                      "--fa-primary-color": this.isHolidaySelected()
                        ? "#fefefe" : "#6c757d",
                      "--fa-secondary-color": this.isHolidaySelected()
                        ? "#05a90d"
                        : "#6c757d",
                      "--fa-secondary-opacity": "0.94"
                    }}
                  />
                </a>
                  </div>
                  )}
                </div>

                <div class='tbm-body'>
                  <p>Block time for:</p>
                  <div
                    class='
                  tbm-custom-radio-box
                  d-flex flex-column-fluid flex-lg-row
                  align-items-center
                  justify-content-around
                  custom-radio-outer
                '>
                    <div class='custom-control custom-radio'>
                      <input
                        checked={this.state.formData.type === 'online'}
                        onChange={() => this.handleRadio('online')}
                        disabled={this.isHolidaySelected()}
                        type='radio'
                        class='custom-control-input'
                        id='defaultGroupExample1'
                        name='groupOfDefaultRadios'
                      />
                      <label
                        class='custom-control-label'
                        for='defaultGroupExample1'>
                        Online
                      </label>
                    </div>

                    <div class='custom-control custom-radio'>
                      <input
                        onChange={() => this.handleRadio('physical')}
                        type='radio'
                        class='custom-control-input'
                        id='defaultGroupExample2'
                        name='groupOfDefaultRadios'
                        checked={this.state.formData.type === 'physical'}
                        disabled={this.isHolidaySelected()}
                      />
                      <label
                        class='custom-control-label'
                        for='defaultGroupExample2'>
                        Clinic 1
                      </label>
                    </div>

                    <div class='custom-control custom-radio'>
                      <input
                        onChange={() => this.handleRadio('physical2')}
                        type='radio'
                        class='custom-control-input'
                        id='defaultGroupExample3'
                        name='groupOfDefaultRadios'
                        checked={this.state.formData.type === 'physical2'}
                        disabled={this.isHolidaySelected()}  
                      />
                      <label
                        class='custom-control-label'
                        for='defaultGroupExample3'>
                        Clinic 2
                      </label>
                    </div>

                    {/* <div class='custom-control custom-radio no-margin'>
                      <input
                        checked={this.state.formData.type === 'both'}
                        onChange={e => this.handleRadio('both')}
                        type='radio'
                        class='custom-control-input'
                        id='defaultGroupExample4'
                        name='groupOfDefaultRadios'
                      />
                      <label
                        class='custom-control-label'
                        for='defaultGroupExample4'>
                        All
                      </label>
                    </div> */}
                  </div>
                  {!this.isHolidaySelected() && (
                    <div class='form-group d-flex flex-column flex-lg-row align-items-lg-center mt-3'>
                      {this.state.fullDay ? null : (
                        <div className='d-flex'>
                          <SelectOptions
                            name='startTime'
                            attrind={0}
                            attrnum='0'
                            onChange={this.selectChangeOption}
                            value={uniqueOptions.find(
                              es => es.value === this.state.startTime
                            ) || null }
                            nameCl='small ml-0'
                            options={uniqueOptions}
                          />

                          <label
                            className='form-check-label mx-2'
                            htmlFor='flexCheckMon'>
                            to
                          </label>

                          <SelectOptions
                            name='endTime'
                            attrind={1}
                            attrnum='1'
                            onChange={this.selectChangeOption}
                            value={uniqueOptions.find(
                              es => es.value === this.state.endTime
                            ) || null }
                            nameCl='small'
                            options={uniqueOptions}
                          />
                        </div>
                      )}

                      <div className='schedule-day'>
                        <div className='form-check'>
                          <input
                            name='mon'
                            onChange={e =>
                              this.setState({ fullDay: e.target.checked })
                            }
                            className='form-check-input'
                            type='checkbox'
                            value=''
                            id='flexCheckMon'
                            checked={this.state.fullDay}
                          />
                          <label
                            className='form-check-label ml-0'
                            htmlFor='flexCheckMon'>
                            Full Day
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

            {!this.isHolidaySelected() &&
              this.state.offSchedules &&
                this.state.offSchedules
                  .filter(
                    ele =>
                      moment.utc(ele.start).format('YYYY-MM-DD') ===
                      moment(this.state.selectedSlot.start).format('YYYY-MM-DD')
                  )
                  // .filter(ele => ele.type === this.state.formData.type)
                  .map((ele, i) => (
                    <React.Fragment key={ele._id}>
                      {i === 0 && <div>Blocked time slots</div>}

                      <div className='d-flex align-items-center pb-3'>
                        {ele.end ? (
                          <p className='mb-0'>
                            <strong>
                              {ele.type === 'holiday'
                                ? 'Holiday'
                                : ele.type === 'online'
                                  ? 'Online'
                                  : ele.type === 'physical'
                                    ? 'Clinic 1'
                                    : ele.type === 'physical2'
                                      ? 'Clinic 2'
                                      : ele.type}
                            </strong>{' '}—{' '}
                            <strong>
                              {moment(ele.start).utc().format('h:mm a')}{' '}
                              {ele.start_time}
                            </strong>{' '}
                            to{' '}
                            <strong>
                              {moment(ele.end).utc().format('h:mm a')}
                              {ele.end_time}
                            </strong>
                          </p>
                        ) : (
                          <p className='mb-0'>
                            <strong>
                              {ele.type === 'holiday'
                                ? 'Holiday'
                                : ele.type === 'online'
                                  ? 'Online'
                                  : ele.type === 'physical'
                                    ? 'Clinic 1'
                                    : ele.type === 'physical2'
                                      ? 'Clinic 2'
                                      : ele.type}
                            </strong>{' '}
                            — All Slots Blocked
                          </p>
                        )}

                        <a
                          onClick={() => {
                            this.unBlock(ele._id)
                          }}
                          href='#!'
                          className='btn btn-sm btn-default no-shadow ml-3'>
                          Unblock
                        </a>
                      </div>
                    </React.Fragment>
                  )
                )
            }
            {!this.isHolidaySelected() && (
              <div class='tbm-footer d-flex align-items-center'>
                <a
                  disable={this.state.loading}
                  onClick={e => this.toggleTimeModel(e)}
                  href='#!'
                  className={
                    this.state.loading
                      ? 'btn btn-outline no-shadow disabled'
                      : 'btn btn-outline no-shadow'
                  }
                  data-dismiss='modal'>
                  Cancel
                </a>
                {this.state.loading ? (
                  <a class='btn btn-default no-shadow btn-loading'>
                    <img src={loaderIcon} alt='' />
                  </a>
                ) : (
                <button
                  type='button'
                  onClick={this.submitForm}
                  disabled={
                    !this.state.fullDay &&
                    (!this.state.startTime || !this.state.endTime)
                  }
                  className='btn btn-default no-shadow'
                >
                  Submit
                </button>
                )}
              </div>
            )}
          </div>
          )}
          </Modal>
          <Modal
            className='modal fade custom-modal'
            show={this.state.popUp}
            onHide={this.toggle}>
            <div class='modal-body'>
              <h6>Modify Appointment?</h6>
              <p>Do you wish to cancel or reschedule your appointment</p>
              <div class='custom-modal-btn'>
                <a
                  onClick={e => this.reSchule(e)}
                  href='#!'
                  class='btn btn-primary no-shadow btn-block'>
                  Reschedule Appointment
                </a>
                <a
                  disabled={this.state.loader}
                  href='#!'
                  class={
                    this.state.loader
                      ? 'btn-text mb-3 disabled'
                      : 'btn-text mb-3'
                  }
                  onClick={e => this.cancellAppointment(e)}>
                  Cancel Appointment
                </a>
                <a href='#!' class='btn-text' onClick={this.toggle}>
                  Don’t Modify
                </a>
              </div>
            </div>
          </Modal>
          <Modal
            className='modal fade custom-modal'
            show={this.state.popUp2}
            onHide={this.toggle2}>
            <div class='modal-body'>
              <h6>Are you sure you want to Disconnect the Google Calander?</h6>
              <div class='custom-modal-btn'>
                <a
                  href='#!'
                  class={'btn btn-outline btn-block'}
                  onClick={e => this.handleDisconnect(e)}>
                  Yes
                </a>
                <a href='#!' class='btn btn-primary btn-block' onClick={this.toggle2}>
                  No
                </a>
              </div>
            </div>
          </Modal>
        </div>
      </>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  loadSeo: page_key => dispatch(loadSeo(page_key)),
  loadDoctorProfile: () => dispatch(loadDoctorProfile()),
  loadoffSchedule: () => dispatch(loadoffSchedule()),
  loadAllAppointmentForDoctor: params =>
    dispatch(loadAllAppointmentForDoctor(params)),
  loadAppointmentDetail: (id, callback) =>
    dispatch(loadAppointmentDetail(id, callback)),
  offSchedule: (payLoad, callback) => dispatch(offSchedule(payLoad, callback)),
  offScheduleDeactivate: (payLoad, callback) =>
    dispatch(offScheduleDeactivate(payLoad, callback)),
  cancellAppointment: (id, callBack) => dispatch(calcelByDoctor(id, callBack)),
  disconnectCalander: (callBack) => dispatch(disconnectCalander(callBack)),
})
const mapStateToProps = state => ({
  profileLoading: getDoctor(state).profileLoading,
  doctorProfile: getDoctor(state).profile,

  offSchedules: getDoctor(state).offSchedules,
  offSchedulesLoading: getDoctor(state).offSchedulesLoading,
  getAppointment: getAppointment(state).doctorAppointment,
  loadingDoctorAppointment: getAppointment(state).loadingDoctorAppointment,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Calender)
)
